<template>
    <div id="navigation">
        <div class="container navigation-padding">
            <nav class="navbar navbar-expand-md navbar-light navigation-padding">
              <ul class="navbar-nav mr-auto">
                  <li class="nav-item">
                      <a class="nav-link home-link ml-lg-0 mt-lg-3" href="/" v-if="$route.path != '/'">Home</a>
                  </li>
              </ul>
              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent" ref="menu">
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <div @click="goTo('about-me')" class="nav-link pl-lg-3 mt-lg-3">About Me</div>
                  </li>
                  <li class="nav-item">
                    <div @click="goTo('skills')" class="nav-link pl-lg-3 mt-lg-3">Skills</div>
                  </li>
                  <li class="nav-item">
                    <div @click="goTo('contact')" class="nav-link pl-lg-3 mt-lg-3">Contact Me</div>
                  </li>
                </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Navbar',
  methods: {
    goTo(anchor) {
      location.replace("/#" + anchor);
      this.$refs.menu.classList.remove('show');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  border: 0;
}
.home-link {
  margin-left: 1rem;
}        
.nav-link {
  font-size: 1.2rem;
  cursor: pointer;
}
</style>
